import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  input,
  OnInit,
  viewChild,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TurnstileService } from '@core/services';
import { ButtonComponent } from '@shared/components/button/button.component';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { CheckboxComponent } from '@shared/components/form-fields/checkbox/checkbox.component';
import { InputComponent } from '@shared/components/form-fields/input/input.component';
import { SelectComponent } from '@shared/components/form-fields/select/select.component';
import { HowToPlayComponent } from '@shared/components/how-to-play/how-to-play.component';
import { TemplateComponent } from '@shared/components/template/template.component';
import {
  AuthFirstVariantConfig,
  CetoineAuthPayload,
  EmitterKeys,
} from '@shared/models';
import { SafePipe } from '@shared/pipes';

import { AuthBaseComponent } from '../auth.base.component';

@Component({
  selector: 'b2c-variant1',
  styleUrl: './variant1.component.scss',
  templateUrl: './variant1.component.html',
  imports: [
    SafePipe,
    RouterLink,
    FormsModule,
    InputComponent,
    SelectComponent,
    ButtonComponent,
    FooterComponent,
    CheckboxComponent,
    TemplateComponent,
    HowToPlayComponent,
    ReactiveFormsModule,
  ],
})
export class Variant1Component
  extends AuthBaseComponent
  implements OnInit, AfterViewInit
{
  config = input.required<AuthFirstVariantConfig>();

  public cardNumberLabel = '913572';
  public defaultCardType = 'carrefour';
  public shortLocale = this.locale.substring(0, 2);
  public cardPrefixes: Record<string, { displayed: string; hidden: string }> = {
    carrefour: { displayed: '913572', hidden: '' },
    pass_gold: { displayed: '065', hidden: '103' },
    pass_standard: { displayed: '055', hidden: '103' },
    pass_world_elite: { displayed: '065', hidden: '103' },
  };

  turnstileContainer = viewChild.required<ElementRef>('turnstileContainer');

  private _authForm: FormGroup = new FormGroup({});
  private readonly turnstileService = inject(TurnstileService);

  get authForm(): FormGroup {
    return this._authForm;
  }

  ngOnInit(): void {
    this._authForm = this.initForm([
      ...this.config().header.formWrapper.form.fields,
      ...(this.config().header.formWrapper.form.additionalFields || []),
    ]);
  }

  ngAfterViewInit(): void {
    if (this.turnstileService.isLoaded) {
      this.turnstileService
        .getToken(this.turnstileContainer().nativeElement)
        .then();
    }
  }

  submit(): void {
    if (this.authForm.invalid) {
      this.showErrorMessage.set(true);
      return;
    }

    if (this.formSubmitted()) {
      return;
    }

    this.triggerSubmitEvents();

    this.formSubmitted.set(true);

    this.showErrorMessage.set(false);

    const payload: CetoineAuthPayload = this.authForm.value;

    payload.card_number = `${this.cardPrefixes[this.defaultCardType].hidden}${
      this.cardPrefixes[this.defaultCardType].displayed
    }${payload.card_number}`;

    payload.turnstile_token = this.turnstileService.token;
    this.authenticate(payload);
  }

  onCardTypeChanged(cardType: string): void {
    this.defaultCardType = cardType;
    this.cardNumberLabel = this.cardPrefixes[cardType].displayed;
  }

  private triggerSubmitEvents(): void {
    this.taggingService.emitTagForKey(EmitterKeys.LOGIN_BUTTON);
  }
}
